var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"className":"x-tc-cnt flex flex-wrap"}},[_vm._m(0),_c('div',{ref:"LiuLiangRef2",staticStyle:{"width":"100%","height":"500px","margin-left":"20px"}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"absolute","right":"30px"}},[_c('span',[_vm._v(" 当前流量："),_c('span',{attrs:{"className":"text-green-2"}},[_vm._v("2 m³/s")])])])
}]

export { render, staticRenderFns }